import { Currency, Locale } from '@synergy/models';
import { getLocalizedString } from '@synergy/utils';

import { WishListArticle } from '../wish-list';
import { WishListArticleDto } from '../dto/wish-list-dto';

export const mapWishListArticle = (
    locales: Locale[],
    currency: Currency,
    article: WishListArticleDto
): WishListArticle | null => {
    const result: WishListArticle = {
        id: article.id,
        name: getLocalizedString(locales, article.name),
        number: article.number,
        contentUnit: getLocalizedString(locales, article.contentUnit),
        contentQuantity: article.contentQuantity,
        orderUnit: getLocalizedString(locales, article.orderUnit),
        stockStatus: article.stockStatus,
        inventory: article.inventory,
        deliveryStatus: article.deliveryStatus,
        deliveryTimeInDays: article.deliveryTimeInDays,
        minimumOrderQuantity: article.minimumOrderQuantity,
        maximumOrderQuantity: article.maximumOrderQuantity,
        quantityInterval: article.quantityInterval,
        recommendedOrderQuantity: article.recommendedOrderQuantity,
        priceQuantity: article.priceQuantity,
        isBestPrice: article.isBestPrice ?? false,
        mainPrice: article.prices?.mainPrice ?? 0,
        specialPrice: article.prices?.specialPrices?.[0],
        globalTradeItemNumber: article.globalTradeItemNumber,
        attributes: article.attributes ?? [],
        currency,
    };

    return result;
};
